import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import PageSwiperStore from '@src/components/swiper/page-swiper/store';
import { useEffect } from 'react';
import { useRequest } from 'ahooks';
import { computed, observable } from 'mobx';
import useModal from '@src/utils/hooks/use-modal';
import AppointmentModal from './components/appointment-modal';
import AppointmentModalStore from './components/appointment-modal/store';
import NegativeSectionStore from './sections/negative-section/store';
import AppointmentSuccessModal from '@src/business-components/appointment-success-modal';
import AppointmentSuccessModalStore from '@src/business-components/appointment-success-modal/store';
import FirstSectionStore from './sections/first-section/store';
import SecondSectionStore from './sections/second-section/store';
import CreatorsSectionStore from './sections/creators-section/store';
import ThirdSectionStore from './sections/third-section/store';
import FourSectionStore from './sections/four-section/store';
import FiveSectionStore from './sections/five-section/store';
import SixSectionStore from './sections/six-section/store';
import SevenSectionStore from './sections/seven-section/store';
import FooterStore from './components/footer/store';
import TopMenuStore from '@src/business-components/top-menu/store';
import cmsApi from '@src/services/cms-api';
import { CMS_API_CONFIG_ROOT } from '@src/constants/urls';
import getLanguageFolderName from '@src/utils/locale/getLanguageFolderName';
import { $$tracker } from '@src/tracker';
import vhCheck from 'vh-check';
import getRemScale from '@src/utils/get-rem-scale';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';

class MainStore extends BaseStore {
  // 预约弹窗
  appointmentModalStore = new AppointmentModalStore({
    updataConfig: email => {
      // 下载阶段设置一个30分钟的缓存
      console.log(this.downLoadBtnState);
      if (this.downLoadBtnState) {
        // 获取当前时间戳（单位：毫秒）
        const now = Date.now();
        const cacheKey = 'appointmentData'; // 缓存键名
        // 设置缓存有效期为30分钟（1800000毫秒）
        const cacheExpiration = 30 * 60 * 1000;
        // 保存数据到 localStorage，包含数据和时间戳
        const dataToCache = {
          value: 'true',
          timestamp: now
        };
        // 将数据保存到 localStorage
        localStorage.setItem(cacheKey, JSON.stringify(dataToCache));
        // 设置过期时间（30分钟）
        localStorage.setItem(`${cacheKey}_expiration`, now + cacheExpiration);
      }

      this.appointmentSuccessModalStore.email = email;
      this.appointmentSuccessModalStore.isOpen = true;
      this.modals.AppointmentSuccess.open();
    }
  });
  // 预约成功弹窗
  appointmentSuccessModalStore = new AppointmentSuccessModalStore();
  // 导航栏
  topMenuStore = new TopMenuStore({
    clickChangeSwiper: current => {
      this.pageSwiperStore.baseSwiperStore.onChange(current - 1);
    }
  });
  // 整屏轮播
  pageSwiperStore = new PageSwiperStore({
    swiperOptions: {
      // direction: 'horizontal',
      direction: 'vertical',
      effect: 'fade',
      // effect: 'slide',
      slidesPerView: 'auto',
      observer: true,
      observeParents: true,
      mousewheel: true,
      observeSlideChildren: true,
      autoHeight: true,
      initialSlide: 0,
      on: {
        init: function() {
          console.log();
        },
        transitionStart: function() {}
      }
    }
  });

  // 预热页
  negativeSectionStore = new NegativeSectionStore({
    pageSwiperStore: this.pageSwiperStore
  });

  //  首页kv
  firstSectionStore = new FirstSectionStore({
    onBook: () => {
      //
      const cacheKey = 'appointmentData';
      const expirationKey = `${cacheKey}_expiration`;
      // 获取缓存数据和过期时间
      const cachedData = localStorage.getItem(cacheKey);
      const expirationTime = localStorage.getItem(expirationKey);
      const now = Date.now();
      if (cachedData && expirationTime && now < expirationTime) {
        // 如果缓存存在且未过期
        const data = JSON.parse(cachedData);
        // window.open('www.baidu.com');
      } else {
        // 缓存过期或不存在
        this.modals.appointmentModal.open();
        localStorage.removeItem(cacheKey);
        localStorage.removeItem(expirationKey);
      }
      // this.modals.appointmentModal.open();

      $$tracker.clickDownload();
    }
  });
  // 限时活动
  secondSectionStore = new SecondSectionStore({});
  // 创作者
  creatorsSectionStore = new CreatorsSectionStore();
  // 版本亮点
  thirdSectionStore = new ThirdSectionStore();
  // 地图
  fourSectionStore = new FourSectionStore();
  // 空投装备
  fiveSectionStore = new FiveSectionStore();
  // 飞行踏板
  sixSectionStore = new SixSectionStore();
  // 敌对目标
  sevenSectionStore = new SevenSectionStore();
  // 底部版权
  footerStore = new FooterStore();

  @observable download_status;

  // 是否第一次加载倒计时页面
  @observable isFirstLoadNegativeSection = true;

  // 赛事页面是否显示
  @observable isOpenCompetition = false;

  /**
   * 页面模块跟新切换-通知当前页面
   *  每个模块添加一个 isActive 变量
   * @param current
   */
  @computed
  get pageStore() {
    return [
      // this.negativeSectionStore,
      this.firstSectionStore,
      ...(this.isOpenCompetition ? [this.secondSectionStore] : []), // 根据 isOpenCompetition 动态决定是否加入 secondSectionStore
      this.thirdSectionStore,
      this.fourSectionStore,
      this.fiveSectionStore,
      this.sixSectionStore,
      this.sevenSectionStore,
      this.footerStore
    ];
  }

  changePageVisible(current) {
    this.pageStore.map((item, index) => {
      // 滑动到版权页时，将倒数第二个模块（敌对目标）设置为激活状态
      if (current === this.pageStore.length - 1 && index === this.pageStore.length - 2) {
        item.isActive = true;
      } else {
        item.isActive = current === index;
      }
    });
  }

  // 获取下载时间
  downloadStatusAsync = () => {
    return this.$ztService.downloadStatus();
  };

  getCmsConfigAsync = () => {
    return cmsApi.makeCmsCustomConfigRequest(CMS_API_CONFIG_ROOT, `zt/${getLanguageFolderName()}_mechabreak_index_config`);
  };

  // https://www.mechabreak.com/api/config/tag/zt/msmk_page_config?filter=0
  getMsmkPageConfig = async () => {
    return await cmsApi
      .makeCmsCustomConfigRequest('//www.mechabreak.com/api/config/tag/', 'zt/msmk_page_config?filter=0')
      .then(res => {
        // console.log(res);
        this.isOpenCompetition = !!+res?.competition_state;
        this.topMenuStore.isOpenCompetition = !!+res?.competition_state;
        // this.isOpenCompetition = this.topMenuStore.isOpenCompetition = false;
        let newsUrl = getLanguageByPath() === 'zh-Hant' ? 'tc_news_url' : getLanguageByPath() + '_news_url';
        let competition_url = getLanguageByPath() === 'zh-Hant' ? 'tc_competition_url' : getLanguageByPath() + '_competition_url';
        // steam_url
        let steam_url = getLanguageByPath() === 'zh-Hant' ? 'tc_steam_url' : getLanguageByPath() + '_steam_url';

        this.topMenuStore.newsUrl = res[newsUrl];
        this.firstSectionStore.steam_url = res[steam_url];
        this.secondSectionStore.competition_url = res[competition_url];
      })
      .catch(e => {
        console.log(e);
      });
  };

  findIndexByValue(value) {
    const index = this.topMenuStore.navList.findIndex(item => item.id === value);
    return index !== -1 ? index : null;
  }

  use() {
    super.use();
    this.downloadStatus = useRequest(async () => await this.downloadStatusAsync(), {
      manual: false,
      onSuccess: data => {
        this.firstSectionStore.isDownLoadTime = data.download_status;
        this.download_status = data.download_status;
      },
      onError: e => {
        console.log(e);
      }
    });
    this.getCmsConfig = useRequest(this.getCmsConfigAsync, {
      onSuccess: data => {
        this.appointmentSuccessModalStore.twitterLink = data.twitter_link;
        this.appointmentSuccessModalStore.discordLink = data.discord_link;
        this.appointmentSuccessModalStore.youtubeLink = data.youtube_link;
        window.mechabreakConfig = data;
      },
      onError: e => {
        throw new Error('request has error' + e.message);
      }
    });

    this.modals = {
      appointmentModal: useModal(AppointmentModal, { store: this.appointmentModalStore }),
      AppointmentSuccess: useModal(AppointmentSuccessModal, { store: this.appointmentSuccessModalStore })
    };

    useEffect(() => {
      this.pageSwiperStore.baseSwiperStore.onChange(0);
    }, []);

    useMount(async () => {
      //
      this.getMsmkPageConfig();
    });
    useEffect(
      () => {
        if (!this.appointmentModalStore.isOpen || !this.appointmentSuccessModalStore.isOpen) {
          // 当前滚动位置
          const scrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
          if (scrollY > 2) {
            window.scrollTo({
              top: 0,
              behavior: 'auto' // 可以设置为 'smooth' 或 'auto'
            });
          }
        }
      },
      [this.appointmentModalStore.isOpen, this.appointmentSuccessModalStore.isOpen]
    );
    useEffect(() => {
      try {
        const vhCheckResult = vhCheck();
        const remScale = getRemScale();
        this.vhOffset = (vhCheckResult?.offset || 0) * remScale;
      } catch (e) {
        console.error(e);
      }
    }, []);

    useEffect(
      () => {
        // console.log(this.pageSwiperStore?.baseSwiperStore?.activeIndex, '页面角标');
        this.changePageVisible(this.pageSwiperStore?.baseSwiperStore?.activeIndex);
        if (this.pageSwiperStore.baseSwiperStore.activeIndex < this.pageStore.length - 1) {
          const TopCurrentIndex = this.findIndexByValue(this.pageSwiperStore.baseSwiperStore.activeIndex + 1);
          this.topMenuStore.currentIndex = TopCurrentIndex;
        }

        if (this.isFirstLoadNegativeSection && this.pageSwiperStore.baseSwiperStore.activeIndex === 0) {
          this.isFirstLoadNegativeSection = false;
        }
      },
      [this.pageSwiperStore?.baseSwiperStore?.activeIndex]
    );
  }
}

export default MainStore;
